import {Subject} from "rxjs";

export class Events {

    public refresh: Subject<boolean> = new Subject();

}